const loaderIcon = '<svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><defs> <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a"> <stop stop-color="#fff" stop-opacity="0" offset="0%"/> <stop stop-color="#fff" stop-opacity=".631" offset="63.146%"/> <stop stop-color="#fff" offset="100%"/> </linearGradient> </defs> <g fill="none" fill-rule="evenodd"> <g transform="translate(1 1)"> <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2"> <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite" /> </path> <circle fill="#fff" cx="36" cy="18" r="1"> <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite" /> </circle> </g> </g> </svg>';

const initializeCopyLinks = () => {
	const perspectives = document.querySelectorAll( '[data-copy-perspective-link]' );

	perspectives.forEach( perspective => {
		perspective.addEventListener( 'click', () => {
			console.log( 'copy button clicked', perspective );
			const currentPerspective = perspective.closest( '.modal__content' );
			const linkToCopy = currentPerspective.querySelector( '[data-perspective-link-to-copy]' );
			// const copyText = document.querySelector( perspective );
			console.log( linkToCopy );
			linkToCopy.select();
			linkToCopy.setSelectionRange( 0, 99999 );
			document.execCommand( 'copy' );
			perspective.focus();
			const copyNotification = perspective.querySelector( '[data-fade-out-copy]' );
			copyNotification.classList.remove( 'dn' );
			copyNotification.classList.remove( 'fade-out' );
			copyNotification.classList.add( 'fade-out' );
			// add fade-out, remove dn
		} );
	} );
}

const initializeEventPlayers = () => {
	const videoPlayButtons = document.querySelectorAll( '[data-play-video]' );
	videoPlayButtons.forEach( videoPlayButton => {
		videoPlayButton.addEventListener( 'click', () => {
			console.log( 'clicked!' )
			const videoParent = videoPlayButton.closest( '[data-video-container]' );
			const videoPlaceholder = videoParent.querySelector( '[data-video-placeholder]' );
			const loadingButton = videoPlaceholder.querySelector( 'button:not([data-open-single-event])' );
			loadingButton.innerHTML = loaderIcon;
			loadingButton.style.left = '50%';
			loadingButton.style.top = '47%';
			loadingButton.style.maxWidth = '5rem';
			loadingButton.style.width = '5rem';
			const video = videoParent.querySelector( '[data-perspective-video]' );
			const videoHolder = videoParent.querySelector( '.video-holder' );
			videoHolder.classList.add( 'dn' );
			const perspectiveVideo = new Plyr( video, {
				captions: {
					active: true
				},
				vimeo: {
					quality: '720p'
				}
			} );
			perspectiveVideo.on( 'ready', () => {
				perspectiveVideo.play();
			} );
			perspectiveVideo.on( 'playing', () => {
				videoHolder.classList.remove( 'dn' );
				videoPlaceholder.remove();
			} );
		} );
	} );
}

/**
 * Update visible events based on what radio button is checked.
 *
 * @param {HTMLInputElement} option The option element.
 */
const updateEvents = ( option ) => {
	const allEvents = document.querySelectorAll( '[data-event-type]' )
	const eventTypeExists = document.querySelector( `[data-event-type="${option.value}"]` );
	if ( eventTypeExists ) {
		const events = document.querySelectorAll( `[data-event-type="${option.value}"]` );
		allEvents.forEach( event => { event.style.display = 'none' } )
		events.forEach( event => { event.style.display = 'block' } )
	} else {
		allEvents.forEach( event => { event.style.display = 'block' } )
	}
}

/**
 * Logic for showing and hiding past events based on event type.
 */
const setupEventsFilter = () => {
	const formFilter = document.querySelector( '[data-filter-past-events]' );
	if ( formFilter ) {
		const options = formFilter.querySelectorAll( 'input[type="radio"]' )
		const checked = formFilter.querySelector( 'input[type="radio"]:checked' )
		if ( checked ) updateEvents( checked )
		options.forEach( option => option.addEventListener( 'change', () => { updateEvents( option ) } ) )
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	const modalTriggers = document.querySelectorAll( '[data-open-single-event]' )
	modalTriggers.forEach( trigger => {
		trigger.addEventListener( 'click', () => {
			console.log( 'event trigger', trigger )
			MicroModal.show( 'single-event-modal' );
			const singleEventModalContent = document.querySelector( '#single-event-modal-content' )
			const videoContainer = trigger.closest( '[data-video-container]' )
			const videoParentContainer = trigger.closest( '[data-video-id]' )
			const videoParent = trigger.closest( '.video.perspective' )
			const title = videoParent.querySelector( '.metadata .title' )
			const videoContainerClone = videoContainer.cloneNode( true )
			console.log( 'videoContainer', videoContainer )
			const videoHolder = videoContainer.querySelector( '.video-holder' )
			console.log( 'videoHolder', videoHolder )
			const modalContent = document.querySelector( '#single-event-modal [data-past-event-modal-content]' );
			modalContent.innerHTML = ''
			modalContent.append( videoContainerClone );
			const singleEventModalTrigger = modalContent.querySelector( '[data-open-single-event]' )
			const playTrigger = modalContent.querySelector( '[data-play-podcast], [data-play-video]' )
			singleEventModalTrigger.style.display = 'none';
			if ( playTrigger ) playTrigger.style.display = 'block';
			const podcastDisplay = modalContent.querySelector( '.podcast-embed' );
			if ( podcastDisplay ) podcastDisplay.style.display = 'block';
			const singleEventTitle = document.querySelector( '#single-event-modal [data-past-event-title]' )
			singleEventTitle.innerHTML = ''
			singleEventTitle.innerHTML = title.innerHTML || ''
			const pastEventCopyLink = document.querySelector( '[data-past-event-copy-link]' );
			pastEventCopyLink.innerHTML = ''
			const copyEvent = videoParentContainer.querySelector( '[data-copy-video-link]' )
			const copyEventClone = copyEvent.cloneNode( true );
			pastEventCopyLink.append( copyEventClone )
			initializeEventPlayers()
			initializeCopyLinks()
		} )
	} )

	setupEventsFilter()

} )

